export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1474674556023-efef886fa147?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    chamber: "https://images.pexels.com/photos/38406567/pexels-photo-38406567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    molten: "https://images.unsplash.com/photo-1613970351372-9804e380bd09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    factory: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    plc: "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    controlRoom: "https://images.unsplash.com/photo-1558054665-fbe00cd7d920?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    wiring: "https://images.unsplash.com/photo-1753272691001-4d68806ac590?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    engineer: "https://images.unsplash.com/photo-1735494032948-14ef288fc9d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    fabrication: "https://images.unsplash.com/photo-1673201159772-a3b7fa2ecc5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const COMPANY = {
    name: "SS ENGINEERING WORKS",
    tagline: "HEAT | TECHNOLOGY | A STRONGER TOMORROW",
    secondary: "ENGINEERED FOR EXTREME POSSIBILITIES",
    established: "Since 2026",
    phone1: "+91 9811273588",
    phone2: "+91 8375019925",
    email: "ssengineeringworks643@gmail.com",
    gstin: "09BJDPS8411A1ZD",
    address: "Plot No. 200, Block-A, Brindavan Garden, Greater Noida, Gautam Buddha Nagar, Uttar Pradesh – 201318, India",
    whatsapp: "https://wa.me/919811273588?text=Hello%20SS%20Engineering%20Works%2C%20I%20would%20like%20to%20discuss%20an%20industrial%20furnace%20requirement.",
};

export const NAV_LINKS = [
    { label: "HOME", to: "/" },
    { label: "ABOUT US", to: "/about" },
    { label: "PRODUCTS", to: "/products" },
    { label: "SOLUTIONS", to: "/solutions" },
    { label: "INDUSTRIES", to: "/industries" },
    { label: "SERVICES", to: "/services" },
    { label: "PROJECTS", to: "/projects" },
    { label: "QUALITY", to: "/quality" },
    { label: "CONTACT", to: "/contact" },
];

export const PRODUCTS = [
    {
        slug: "electric-industrial-furnaces",
        name: "Electric Industrial Furnaces",
        tag: "FURNACE SYSTEMS",
        desc: "Custom-built electric resistance furnaces engineered for reliable high-temperature operation in demanding industrial environments.",
        apps: ["Batch & continuous heating", "Metal processing", "Component heating", "Process pre-heating"],
        features: ["Electric resistance heating", "Engineered chamber construction", "Multi-zone temperature control", "Energy-conscious insulation design", "Integrated safety interlocks"],
        image: IMAGES.chamber,
    },
    {
        slug: "heat-treatment-furnaces",
        name: "Heat Treatment Furnaces",
        tag: "THERMAL PROCESSING",
        desc: "Furnace systems designed for controlled heat treatment cycles including hardening, tempering, annealing and stress relieving.",
        apps: ["Hardening & tempering", "Annealing", "Normalizing", "Stress relieving"],
        features: ["Programmable cycle control", "Uniform temperature distribution", "Atmosphere-ready design options", "Data logging capability", "Robust industrial construction"],
        image: IMAGES.molten,
    },
    {
        slug: "industrial-heating-systems",
        name: "Industrial Heating Systems",
        tag: "HEATING EQUIPMENT",
        desc: "Electric heating systems for ovens, chambers and process equipment — engineered around the required thermal profile.",
        apps: ["Industrial ovens", "Drying & curing", "Pre-heating systems", "Thermal chambers"],
        features: ["Application-specific heater selection", "SCR / thyristor power control", "PID temperature regulation", "Modular system architecture", "Service-friendly layout"],
        image: IMAGES.hero,
    },
    {
        slug: "process-heating-systems",
        name: "Process Heating Systems",
        tag: "PROCESS SYSTEMS",
        desc: "Integrated process heating solutions combining furnace, electrical and control engineering into a single dependable system.",
        apps: ["Continuous process lines", "Temperature-controlled processes", "Thermal treatment plants", "Custom process equipment"],
        features: ["Turnkey system engineering", "Furnace + panel + automation integration", "Process monitoring & logging", "Scalable configurations", "Commissioning support"],
        image: IMAGES.factory,
    },
    {
        slug: "furnace-control-panels",
        name: "Furnace Control Panels",
        tag: "CONTROL SYSTEMS",
        desc: "Electrical control panels purpose-built for furnace and heating applications — power switching, control and protection in one enclosure.",
        apps: ["Furnace power control", "Heater switching", "Temperature control panels", "MCC & distribution"],
        features: ["Thyristor / contactor-based control", "Over-temperature protection", "Quality switchgear components", "Clear wiring & documentation", "Panel testing before dispatch"],
        image: IMAGES.plc,
    },
    {
        slug: "plc-hmi-automation-systems",
        name: "PLC / HMI Automation Systems",
        tag: "AUTOMATION",
        desc: "PLC and HMI based automation for furnace and process systems — recipe control, sequencing, alarms and operator interfaces.",
        apps: ["Furnace automation", "Recipe & cycle management", "Process sequencing", "Remote monitoring"],
        features: ["PLC-based control logic", "Touchscreen HMI interfaces", "Alarm & event management", "Trend & data logging", "SCADA-ready architecture"],
        image: IMAGES.controlRoom,
    },
    {
        slug: "temperature-control-systems",
        name: "Temperature Control Systems",
        tag: "INSTRUMENTATION",
        desc: "Precision temperature measurement and control systems — controllers, sensors and instrumentation for consistent thermal processes.",
        apps: ["Multi-zone control", "Thermocouple systems", "Process instrumentation", "Calibration-sensitive processes"],
        features: ["PID temperature controllers", "Thermocouples & RTDs", "Over-temperature trips", "Multi-zone architectures", "Recorder & logger options"],
        image: IMAGES.wiring,
    },
    {
        slug: "heating-element-systems",
        name: "Heating Element Systems",
        tag: "HEATING ELEMENTS",
        desc: "Electric heating element systems selected and engineered for the furnace duty — including element design, support and replacement spares.",
        apps: ["Resistance heating elements", "Element replacement & spares", "Radiant heating systems", "Custom heater assemblies"],
        features: ["Application-matched element alloys", "Engineered element support systems", "Zone-balanced heater design", "Spare & retrofit supply", "Service-friendly access"],
        image: IMAGES.fabrication,
    },
    {
        slug: "electrical-power-control-systems",
        name: "Electrical Power & Control Systems",
        tag: "ELECTRICAL SYSTEMS",
        desc: "Power distribution and control engineering for industrial heating plants — from incoming supply to heater terminals.",
        apps: ["Power distribution panels", "MCC systems", "Heating power regulation", "Plant electrical integration"],
        features: ["Load-engineered power design", "Protection & metering", "Harmonics-aware thyristor control", "Compliant panel fabrication", "Complete electrical documentation"],
        image: IMAGES.engineer,
    },
];

export const SOLUTIONS = [
    {
        title: "Thermal Solutions",
        desc: "Industrial heating engineered around your process temperature, cycle and throughput requirements.",
        items: ["Industrial heating", "Heat treatment", "Temperature-controlled processes", "Custom furnace solutions"],
        image: IMAGES.chamber,
    },
    {
        title: "Electrical Solutions",
        desc: "Power and control engineering built for the demands of electric heating equipment.",
        items: ["Power distribution", "Furnace electrical panels", "MCC / control systems", "Heating power control"],
        image: IMAGES.plc,
    },
    {
        title: "Automation Solutions",
        desc: "Control and monitoring that makes thermal processes consistent, visible and repeatable.",
        items: ["PLC", "HMI", "Temperature controllers", "Sensors", "Process monitoring", "Data logging"],
        image: IMAGES.controlRoom,
    },
    {
        title: "Integrated Solutions",
        desc: "Complete systems where furnace, electrical and automation engineering arrive as one.",
        items: ["Furnace + electrical panel", "Furnace + PLC/HMI", "Furnace + automation", "Complete process heating systems"],
        image: IMAGES.factory,
    },
];

export const INDUSTRIES = [
    { name: "Metal & Engineering", image: IMAGES.fabrication },
    { name: "Automotive", image: IMAGES.factory },
    { name: "Aerospace", image: IMAGES.engineer },
    { name: "Tool & Die", image: IMAGES.molten },
    { name: "Foundry", image: IMAGES.chamber },
    { name: "Manufacturing", image: IMAGES.hero },
    { name: "Electrical & Electronics", image: IMAGES.wiring },
    { name: "Pharmaceutical", image: IMAGES.controlRoom },
    { name: "Research & Development", image: IMAGES.plc },
    { name: "Specialty Materials", image: IMAGES.molten },
];

export const SERVICES = [
    { name: "Engineering & Design", desc: "Thermal, electrical and mechanical engineering of furnace and process systems around your requirements.", icon: "DraftingCompass" },
    { name: "Fabrication & Manufacturing", desc: "In-house fabrication and assembly of furnace structures, chambers and associated equipment.", icon: "Factory" },
    { name: "Electrical & Control Panel Design", desc: "Design and build of furnace control panels, power panels and MCC systems with full documentation.", icon: "Zap" },
    { name: "PLC / HMI Automation", desc: "Automation engineering — PLC logic, HMI interfaces, recipe control, alarms and data logging.", icon: "Cpu" },
    { name: "Installation", desc: "Structured on-site installation of furnaces, panels and systems by the engineering team.", icon: "Wrench" },
    { name: "Testing & Commissioning", desc: "Electrical testing, control verification, temperature profiling and process commissioning.", icon: "ClipboardCheck" },
    { name: "Service & Maintenance", desc: "Preventive maintenance, troubleshooting, spares and technical support for installed systems.", icon: "Settings" },
    { name: "Retrofit & Upgradation", desc: "Control upgrades, re-lining, element replacement and modernization of existing furnaces.", icon: "RefreshCw" },
];

export const PROCESS_STEPS = [
    { n: "01", title: "Understand", desc: "Process requirements, temperature profile, throughput and site conditions." },
    { n: "02", title: "Engineer", desc: "Thermal and electrical engineering of the right solution architecture." },
    { n: "03", title: "Design", desc: "Detailed mechanical, refractory, electrical and control design." },
    { n: "04", title: "Manufacture", desc: "Fabrication, machining, panel building and assembly." },
    { n: "05", title: "Test", desc: "Electrical tests, control checks and furnace performance verification." },
    { n: "06", title: "Install", desc: "On-site erection, positioning and utility connections." },
    { n: "07", title: "Commission", desc: "Process trials, temperature profiling and handover." },
    { n: "08", title: "Support", desc: "Service, spares, troubleshooting and technical assistance." },
];

export const WHY_US = [
    { title: "Engineering-Led Approach", desc: "Integrated thermal, electrical and automation engineering.", icon: "Cog" },
    { title: "Custom Engineered Solutions", desc: "Solutions designed around process requirements.", icon: "PenTool" },
    { title: "Precision Control", desc: "Temperature and process control designed for consistent operation.", icon: "Gauge" },
    { title: "Integrated Automation", desc: "PLC, HMI, instrumentation and electrical control integration.", icon: "Cpu" },
    { title: "Manufacturing Focus", desc: "Engineering translated into practical, maintainable equipment.", icon: "Factory" },
    { title: "After-Sales Support", desc: "Service, troubleshooting and technical support.", icon: "Headphones" },
];

export const PROJECTS = [
    { title: "Electric Heat Treatment Furnace", industry: "Metal & Engineering", equipment: "Heat treatment furnace with control panel", scope: "Design, manufacture, installation & commissioning", location: "Details on request", year: "On request", image: IMAGES.molten },
    { title: "Process Heating System", industry: "Manufacturing", equipment: "Process heating system with PLC automation", scope: "Engineering, supply & commissioning", location: "Details on request", year: "On request", image: IMAGES.hero },
    { title: "Furnace Automation Upgrade", industry: "Tool & Die", equipment: "PLC / HMI control system retrofit", scope: "Retrofit, panel replacement & commissioning", location: "Details on request", year: "On request", image: IMAGES.controlRoom },
];

export const QUALITY_SECTIONS = [
    { title: "Engineering Quality", desc: "Every system begins with documented engineering — thermal calculations, electrical design and control architecture reviewed before manufacturing begins." },
    { title: "Manufacturing Quality", desc: "Fabrication and assembly follow defined workmanship practices, with stage checks through the build process." },
    { title: "Electrical Testing", desc: "Panels and power systems undergo insulation, continuity, functional and protection checks before dispatch." },
    { title: "Control Panel Testing", desc: "Control logic, interlocks, alarms and HMI functions are verified against the project specification." },
    { title: "Furnace Performance Checks", desc: "Heat-up behaviour, temperature uniformity and control stability are verified during testing and commissioning." },
    { title: "Documentation", desc: "Projects are supported with drawings, test reports and operation documentation as applicable." },
    { title: "Final Inspection", desc: "A final inspection is carried out before dispatch, covering mechanical, electrical and control scope." },
];

export const QUALITY_DOCS = [
    "Technical drawings",
    "Electrical drawings",
    "Test reports",
    "Inspection documents",
    "Operation manuals",
    "Maintenance documentation",
];

export const SPEC_ROWS = [
    ["Operating Temperature", "To be specified — available on request"],
    ["Working Chamber", "To be specified — available on request"],
    ["Heating Method", "Electric Resistance Heating"],
    ["Control", "PLC / HMI / PID / As specified"],
    ["Power Supply", "To be specified — available on request"],
    ["Instrumentation", "Thermocouples / Recorders / As specified"],
];
